import React from 'react';
import Moment from "react-moment";

const FormatDate = (props) => (
  <Moment format={props.format} dateval={new Date(props.date).toJSON()} className={props.className}>
    {props.date}
  </Moment>
);

export default FormatDate;